import React from "react";

import { useBotEmbed } from "./BotEmbedContext";
import BotWidget from "./BotWidget";

const PreviewSurface = () => {
  const { config, isLoadingConfig, isUsingFallback, loadError } = useBotEmbed();

  return (
    <div className="bb-embed-page bb-embed-page--preview">
      <div className="bb-embed-preview-shell">
        <div className="bb-embed-hero">
          <span className="bb-embed-kicker">Third-party preview surface</span>
          <h1>
            Launch the same embedded bot UI on-site, in test routes, and through
            the standalone script.
          </h1>
          <p>
            The UI reads the bot embed API by bot id, then applies the returned
            appearance settings directly to the launcher, header, bubbles,
            footer, sizing, and supporting metadata.
          </p>
        </div>

        <div className="bb-embed-grid">
          <div className="bb-embed-card">
            <h3>Appearance-aware</h3>
            <p>
              Header color, bubbles, input surfaces, fonts, and launcher styling
              are all driven from the embed settings response.
            </p>
          </div>
          <div className="bb-embed-card">
            <h3>Multi-page ready</h3>
            <p>
              The script build mounts inside a shadow root, which helps keep
              host app styles from leaking into the widget.
            </p>
          </div>
          <div className="bb-embed-card">
            <h3>Single component</h3>
            <p>
              `BotEmbed` is now the shared source for `/bot-preview`,
              `/bot-test`, and `embed/chatbot.js`.
            </p>
          </div>
        </div>

        <div className="bb-embed-preview-grid">
          <div className="bb-embed-surface">
            <div className="bb-embed-surface-inner">
              <div className="bb-embed-masthead">
                <div className="bb-embed-brand">
                  <span className="bb-embed-brand-badge">BB</span>
                  <div>
                    <strong>{config.bot_name}</strong>
                    <div className="bb-embed-meta-line">
                      Bot ID: {config.setting_id} | Domain:{" "}
                      {config.domain_link || "/bot-preview"}
                    </div>
                  </div>
                </div>
                <div className="bb-embed-chip-row">
                  <span className="bb-embed-chip">{config.template_name}</span>
                  <span className="bb-embed-chip">{config.fontBody}</span>
                  <span className="bb-embed-chip">
                    {isLoadingConfig
                      ? "Loading API settings"
                      : isUsingFallback
                        ? "Fallback settings"
                        : "Live API settings"}
                  </span>
                </div>
              </div>

              <div className="bb-embed-panels">
                <div className="bb-embed-product-card">
                  <strong>Brand controls</strong>
                  <p className="bb-embed-meta-line">
                    Bot name: {config.bot_name}
                    <br />
                    Language: {config.language}
                    <br />
                    Tone: {config.tone}
                  </p>
                </div>
                <div className="bb-embed-product-card">
                  <strong>Runtime settings</strong>
                  <p className="bb-embed-meta-line">
                    Position: {config.bot_possition}
                    <br />
                    Model: {config.openRouterModel}
                    <br />
                    Font header: {config.fontHeader}
                  </p>
                </div>
              </div>

              <div className="bb-embed-stat-grid">
                <div className="bb-embed-stat">
                  <strong>{config.width}px</strong>
                  <span>Configured widget width</span>
                </div>
                <div className="bb-embed-stat">
                  <strong>{config.height}px</strong>
                  <span>Configured widget height</span>
                </div>
                <div className="bb-embed-stat">
                  <strong>{config.template_name}</strong>
                  <span>Template source</span>
                </div>
              </div>

              {loadError ? (
                <div className="bb-embed-inline-note bb-embed-status bb-embed-status--fallback">
                  {loadError}
                </div>
              ) : null}
            </div>
          </div>

          <div className="bb-embed-stage">
            <div className="bb-embed-stage-widget">
              <BotWidget />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewSurface;
